import tools from './tools.js';
export default {
    init : function($){
        let body = $('body');
        // fix resize bug
        body.on('click', "[data-menu-open]", function(){
            let t = $(this);
            (t.hasClass("is-active") === true) ? t.removeClass("is-active") : t.addClass("is-active");

            if(t.hasClass("is-active")){
                $('body, #branding').addClass("fixedPosition");
            }else{
                $('body, #branding').removeClass("fixedPosition");
            }
        });

        let branding = document.getElementById('branding');
        let scrollPos = 0;
        let gap = 77;
        let lastScrollDown = false;

        let action = {
            arg: branding,
            fn: (arg) => {
                if(!arg.freezed) {
                    let currentPos = document.body.getBoundingClientRect().top;
                    lastScrollDown = currentPos <= scrollPos;

                    if (Math.abs(scrollPos - currentPos) > gap) {

                        if (scrollPos < - 1 * gap && lastScrollDown ) {
                            branding.classList.add('up');

                        } else if (!lastScrollDown) {
                            branding.classList.remove('up');
                        }
                        scrollPos = currentPos;
                    }
                }
            }
        }

        tools.doOnScroll(action, true, true);
    }
};

